import type { CopyShape } from "../../intl";

import type {
  SHOWCASE_FEATURE_LABELS_COPY_PT_BR,
  SHOWCASE_COUNT_LABELS_COPY_PT_BR,
  SHOWCASE_LIMIT_COPY_PT_BR,
} from "../showcase-features.copy";

export const SHOWCASE_FEATURE_LABELS_COPY_EN_US: CopyShape<
  typeof SHOWCASE_FEATURE_LABELS_COPY_PT_BR
> = {
  "content.tasks": "Tasks",
  "content.scripts": "Scripts",
  "calendar.events": "Calendar events",
  "notes.items": "Notes",

  "campaigns.jobs": "Campaigns",
  "calculator.calculations": "Brand deal quotes",
  "calculator.pdf": "Exported PDFs",
  "calculator.whitelabel": "PDF without Tãmi branding",

  "finance.entries": "Financial history",
  "social.profiles": "Connected socials",
  "social.syncInterval": "Metrics sync",
  "social.history": "Engagement history",

  "assistant.whatsapp": "WhatsApp assistant",
  "assistant.messages": "Messages with the WhatsApp assistant",
  "assistant.audioMinutes": "Voice notes transcribed on WhatsApp",
  "assistant.proactive": "WhatsApp notifications",

  "team.members": "Team members",
  "storage.total": "Storage",
  "storage.perFile": "Size per file",
};

export const SHOWCASE_COUNT_LABELS_COPY_EN_US: CopyShape<
  typeof SHOWCASE_COUNT_LABELS_COPY_PT_BR
> = {
  audioMinutes: { one: "min", other: "min" },
  teamMembers: { one: "member", other: "members" },
};

export const SHOWCASE_LIMIT_COPY_EN_US: CopyShape<
  typeof SHOWCASE_LIMIT_COPY_PT_BR
> = {
  missing: "—",
  days: (limit: number): string => (limit === 1 ? "1 day" : `${limit} days`),
  withDeadline: (value: string, days: string): string => `${value} for ${days}`,
};
